import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { fetchAllTeams } from '../services/allTeams';
import { TeamIdentity } from '../types/index';

export function useGetAllTeams(enabled = true): UseQueryResult<TeamIdentity[]> {
  return useQuery({
    queryKey: ['teams'],
    queryFn: fetchAllTeams,
    enabled,
  });
}
